import { render, staticRenderFns } from "./AddBusiness.vue?vue&type=template&id=f220f296&"
import script from "./AddBusiness.vue?vue&type=script&lang=js&"
export * from "./AddBusiness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports